import React from 'react'

import './Auth.scss'

const Auth = ({ children }) => <div className="layout__auth">{children}</div>

export default Auth
